import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCamera2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="camera-2, picture, image, cam"><path fillRule="evenodd" clipRule="evenodd" d="M8.12666 5C8.98667 3.79079 10.4006 3 12 3C13.5994 3 15.0133 3.79079 15.8733 5H20.25C21.2165 5 22 5.7835 22 6.75V19.25C22 20.2165 21.2165 21 20.25 21H3.75C2.7835 21 2 20.2165 2 19.25V6.75C2 5.7835 2.7835 5 3.75 5H8.12666ZM12 9C10.067 9 8.5 10.567 8.5 12.5C8.5 14.433 10.067 16 12 16C13.933 16 15.5 14.433 15.5 12.5C15.5 10.567 13.933 9 12 9Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCamera2;
